import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-middle-header',
  templateUrl: './middle-header.component.html',
  styleUrls: ['./middle-header.component.scss']
})
export class MiddleHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
